import {
  fetchAllRentalsFail,
  fetchAllRentalsPending,
  fetchAllRentalsSuccess,
} from "../Slices/rentalsSlice";

export const fetchAllRentals = (AuthToken) => async (dispatch) => {
  console.log("Rentals.....");
  dispatch(fetchAllRentalsPending());
  if (AuthToken) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/api/v1/rentals/getAll`,
        {
          method: "GET",
          headers: new Headers({
            "Content-type": "application/json",
            "x-api-key": "6aerc34c54",
            Authorization: "Bearer " + AuthToken,
          }),
        }
      );
      const fetchedRentals = await response.json();
      dispatch(fetchAllRentalsSuccess(fetchedRentals));
      console.log("Rentals", fetchedRentals);
    } catch (error) {
    //   dispatch(fetchAllRentalsFail(error));
      console.log("Rental Error", error);
    }
  } else {
    return;
  }
};
